/**
 * SignupHeader — branded header for the signup portal.
 *
 * Uses the same Oasis Auto Konnect logo asset as oasisautokonnect.com. Two
 * variants swap automatically via Tailwind's dark: class strategy — black
 * logo for light mode, white logo for dark mode.
 *
 * Logo URLs reference oasisautokonnect.com directly (single source of truth
 * for brand assets). If hotlink protection is ever enabled, copy the assets
 * into /public and update the src.
 */

import ThemeToggle from '../../affiliate-portal/ThemeToggle';

const LOGO_BLACK = 'https://oasisautokonnect.com/assets/images/Full-Name-Black.png';
const LOGO_WHITE = 'https://oasisautokonnect.com/assets/images/Full-Name-White.png';

export default function SignupHeader() {
  return (
    <header className="bg-white dark:bg-slate-900 border-b border-slate-200 dark:border-slate-800">
      <div className="max-w-5xl mx-auto px-4 py-4 flex items-center justify-between">
        <a
          href="https://oasisautokonnect.com"
          className="flex items-center group"
          aria-label="Oasis Auto Konnect"
        >
          <img
            src={LOGO_BLACK}
            alt="Oasis Auto Konnect"
            className="h-9 sm:h-10 w-auto block dark:hidden"
            loading="eager"
          />
          <img
            src={LOGO_WHITE}
            alt="Oasis Auto Konnect"
            className="h-9 sm:h-10 w-auto hidden dark:block"
            loading="eager"
          />
        </a>
        <ThemeToggle className="text-slate-600 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-800" />
      </div>
    </header>
  );
}
